export const SPACING_PRESETS = [
  { name: 'None', value: '0' },
  { name: 'Tight', value: 'clamp(1rem, 2vw, 1.5rem)' },
  { name: 'Normal', value: 'clamp(3rem, 6vw, 4rem)' },
  { name: 'Wide', value: 'clamp(5rem, 10vw, 7.5rem)' },
  { name: 'X-Wide', value: 'clamp(7.5rem, 12vw, 10rem)' }
];
